export default "__VITE_ASSET__BgpQ0B2X__"